import { getTranslations } from "@/lib/translations";
import { AuthError } from "@/lib/errors";

import { requireStaffMemberId } from "@/core/auth/admin-guard";
import { createEventService } from "@/core/services/factory";
import { getEventSharePath } from "@/core/services/types/event.types";

export async function createEventAction(
  input: { title?: string } = {},
): Promise<{ redirectTo: string }> {
  const t = getTranslations("events.library");

  let assignedTo: string;

  try {
    assignedTo = await requireStaffMemberId();
  } catch (error) {
    if (error instanceof AuthError) {
      throw new Error(t("createUnauthorized"));
    }
    throw error;
  }

  const result = await createEventService().createEvent({
    ...(input.title ? { title: input.title.trim() } : {}),
    assignedTo,
  });

  if (!result.success) {
    console.error("[createEventAction]", result.error);
    throw new Error(t("createFailed"));
  }

  return { redirectTo: getEventSharePath(result.data.id) };
}

export async function createEventQuickAddAction(input: {
  title: string;
}): Promise<void> {
  const t = getTranslations("events.library");

  let assignedTo: string;

  try {
    assignedTo = await requireStaffMemberId();
  } catch (error) {
    if (error instanceof AuthError) {
      throw new Error(t("createUnauthorized"));
    }
    throw error;
  }

  const result = await createEventService().createEvent({
    title: input.title.trim(),
    status: "SIGNAL",
    assignedTo,
  });

  if (!result.success) {
    throw new Error(
      result.error === "signal_status_failed"
        ? t("createSignalFailed")
        : t("createFailed"),
    );
  }
}
